import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';

import {
  LegacyAllowanceProposalWorkflowTableData,
  LegacyBenefitProposalWorkflowTableData,
  LegacySalaryProposalWorkflowTableData,
} from '~/data/proposals';

type PropsType = {
  columns: GridColDef[];
  rows:
    | LegacyAllowanceProposalWorkflowTableData[]
    | LegacyBenefitProposalWorkflowTableData[]
    | LegacySalaryProposalWorkflowTableData[];
};
export const ProposalsWorkflowTableLayout = (props: PropsType) => {
  const { columns, rows } = props;
  return (
    <DataGridPro
      sx={{ ml: '48px' }}
      autoHeight={true}
      rows={rows}
      columns={columns}
      getRowId={(row) => row.fEmplSubEnteredTime}
      headerHeight={0}
      hideFooterPagination
      hideFooterSelectedRowCount
      hideFooter
    />
  );
};
